export default __webpack_public_path__ + "static/media/Care-Intro.de88d3bc.svg";